import React from 'react'
import { useNavigate } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import RoomItemForm from '../../components/MangeHKT/RoomITemMappingForm'

function CreateRoomItem() {
    const navigate = useNavigate()
    // handleGoBack
    const handleGoBack = () => {
        navigate('/manage-requests')
    }
    
    // create action
    const handleForm = async (propsData) => {
        const { property, roomItem, task } = propsData
        const data = {
            properties_id: Number(property),
            rit_id: Number(task),
            ri_id: Number(roomItem),
          };
        if (data) {
            try {
                const response = await nbrApi.post('/createtaskitemmap', data, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Mapping created successful',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack('/manage-requests');
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Mapping Create failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Mapping Create failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Create Room Mapping</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'><i className='fa fa-undo' /> Go Back</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <RoomItemForm handleAction={handleForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateRoomItem
